import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";

export type IAcknowledgements = onboardingApiSpec.AcknowledgementName[];

export enum WalletCardType {
  Physical = "physical",
  Virtual = "virtual"
}
